var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectInventoryResourceInfo } from "../../selectors/selectInventoryInfo";
import { selectStorageInfo } from "../../selectors/selectStorageInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ProductStats } from "../farm-management/ProductStats";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { getResourceIcon } from "../generic/icon/getResourceIcon";
import { Icon } from "../generic/icon/Icon";
import { TextLoca } from "../generic/text/TextLoca";
import { actionCultivate } from "./actionNursery";
import { RequirementsRecipe } from "./RequirementsRecipe";
export var _DetailViewNursery = function (_a) {
    var item = _a.item, maxStorage = _a.maxStorage, productAmountInInventory = _a.productAmountInInventory, onCultivationClick = _a.onCultivationClick;
    if (item) {
        var productData = __assign({}, item.product[0], { amount: productAmountInInventory });
        var recipeProductLocaKey = item.product[0].locaKey;
        var recipeTitle = recipeProductLocaKey ? (React.createElement(TextLoca, { id: recipeProductLocaKey, className: "" + IdStyles.TextButtonHeading })) : (undefined);
        return (React.createElement("div", { className: "flex flex--guts " + IdStyles.DetailViewWrapper },
            React.createElement("div", { className: "" + IdStyles.DetailView },
                React.createElement("div", { className: "nursery-menu" },
                    React.createElement("div", { className: "flex flex--stacked" },
                        React.createElement("div", null, recipeTitle),
                        React.createElement("div", { className: "flex flex--row" },
                            React.createElement("div", { className: "nursery-menu__icon-wrapper" },
                                React.createElement(Icon, { icon: getResourceIcon(productData), styleId: IdStyles.IconExtraLarge })),
                            React.createElement(ProductStats, { item: productData, maxStorage: maxStorage, className: "flex flex--stacked " + IdStyles.MarketMenuRewardsBackground }))),
                    React.createElement(RequirementsRecipe, { requirements: item.cost }),
                    React.createElement("div", { className: "flex__align-center" },
                        React.createElement(ButtonPrimary, { onClick: function () { return onCultivationClick(item); } },
                            React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.cultivate })))))));
    }
    // tslint:disable-next-line:no-null-keyword
    return null;
};
var mapState = function (state, props) {
    var recipe = props.item;
    var productAmountInInventory = recipe
        ? selectInventoryResourceInfo(state, recipe.product[0].id).amount || Long.ZERO
        : Long.ZERO;
    return {
        maxStorage: selectStorageInfo(state),
        productAmountInInventory: productAmountInInventory,
    };
};
var mapDispatch = function (dispatch) { return ({
    onCultivationClick: function (recipe) { return dispatch(actionCultivate(recipe)); },
}); };
export var DetailViewNursery = connect(mapState, mapDispatch)(_DetailViewNursery);



//////////////////
// WEBPACK FOOTER
// ./src/features/nursery/DetailViewNursery.tsx
// module id = 2727
// module chunks = 3